import React from 'react';
import PropTypes from 'prop-types';

/** 클래스형 Error Boundary */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    /** 자식에서 오류 발생 시 state 갱신 → Fallback 렌더 */
    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    /** 상세 스택트레이스 확보 */
    componentDidCatch(error, errorInfo) {
        this.setState({ errorInfo });
        console.error('Error caught by ErrorBoundary:', error, errorInfo);
    }

    /** Fallback 버튼에서 호출 */
    handleReset = () => {
        this.setState({ hasError: false, error: null, errorInfo: null });
        if (this.props.onReset) this.props.onReset();
    };

    render() {
        const { hasError, error } = this.state;
        const { FallbackComponent, children } = this.props;

        if (hasError) {
            return (
                <FallbackComponent
                    error={error}
                    resetErrorBoundary={this.handleReset}
                />
            );
        }

        return children;
    }
}

ErrorBoundary.propTypes = {
    children: PropTypes.node.isRequired,
    FallbackComponent: PropTypes.elementType.isRequired,
    onReset: PropTypes.func,
};

export default ErrorBoundary;
